/* Maison Brogi — product card quick size picker (snippets/product-card.liquid).
   Delegated listeners, so it also works for cards injected later (Brogi.fetchProductCards, search, tabs).
   Load once globally: <script src="{{ 'brogi-card.js' | asset_url }}" defer></script> in layout/theme.liquid. */
(function () {
  'use strict';
  if (window.__brogiCardInit) return;
  window.__brogiCardInit = true;

  var openPanel = null;

  function toggleFor(panel) {
    var card = panel && panel.closest('.brogi-card');
    return card ? card.querySelector('[data-quick-sizes-open]') : null;
  }

  function close(panel, restoreFocus) {
    panel = panel || openPanel;
    if (!panel) return;
    panel.hidden = true;
    panel.classList.remove('is-open');
    var t = toggleFor(panel);
    if (t) {
      t.setAttribute('aria-expanded', 'false');
      if (restoreFocus) t.focus();
    }
    if (openPanel === panel) openPanel = null;
  }

  function open(panel) {
    if (openPanel && openPanel !== panel) close(openPanel);
    panel.hidden = false;
    // next frame so the CSS transition runs
    requestAnimationFrame(function () { panel.classList.add('is-open'); });
    var t = toggleFor(panel);
    if (t) t.setAttribute('aria-expanded', 'true');
    openPanel = panel;
    var first = panel.querySelector('[data-quick-size]:not([disabled])');
    if (first) first.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-quick-sizes-open]');
    if (opener) {
      e.preventDefault(); e.stopPropagation();
      var card = opener.closest('.brogi-card');
      var panel = card && card.querySelector('[data-quick-sizes]');
      if (!panel) return;
      if (panel.hidden) open(panel); else close(panel);
      return;
    }

    var panelEl = e.target.closest('[data-quick-sizes]');
    if (panelEl) {
      // The picker sits inside the card link: never navigate from inside it.
      e.preventDefault(); e.stopPropagation();

      if (e.target.closest('[data-quick-sizes-close]')) { close(panelEl, true); return; }

      var size = e.target.closest('[data-quick-size]');
      if (!size || size.disabled || size.getAttribute('aria-busy') === 'true') return;
      var id = size.getAttribute('data-quick-size');
      var title = panelEl.getAttribute('data-product-title') || '';
      size.setAttribute('aria-busy', 'true');
      var done = function () { size.removeAttribute('aria-busy'); };
      if (!window.BrogiCart || !BrogiCart.add) { done(); return; }
      BrogiCart.add(id, 1, { title: title })
        .then(function () { close(panelEl); })
        .catch(function () {})
        .then(done, done);
      return;
    }

    // Outside click
    if (openPanel) close(openPanel);
  }, true);

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && openPanel) close(openPanel, true);
  });
})();
